import React from 'react';
export const ShiftAssignmentContext = React.createContext();
export const useShiftAssignmentContext = () =>
    React.useContext(ShiftAssignmentContext);
